import styled from 'styled-components';
import { SIZES, SPACES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';

export const StyledResourceType = styled.div`
  border: 1px solid ${getColor('botticelli')};
  border-radius: 4px;
  padding: 0px 10px;
  margin-right: 10px;
  font-size: ${SIZES.medium};
  &.isDisabled {
    opacity: 0.6;
  }
`;

export const StyledResourceTypeList = styled.section`
  margin-top: ${SPACES.small};
  margin-bottom: ${SPACES.small};
`;
